import { combineReducers } from '@reduxjs/toolkit';
import userRdc from "../features/User/UsersSlice"
import taxonRdc from "../features/Taxons/TaxonSlice"
import filtersRdc from "../features/Products/Slices/ProductFilterSlice"
import productsRdc from "../features/Products/Slices/ProductSlice"
import productBySlugRdc from "../features/Products/ProductDetail/ProductDetailSlice"
import productAssociationCtaRdc from "../features/Products/Slices/ProductAssociationTypesSlice"
import cartOfferRdc from '../features/Offer/OfferCartSlice'
import offerRequestRdc from '../features/Offer/OfferRequestSlice'
import cartRdc from '../features/Cart/CartSlice'
import orderRdc from '../features/Order/OrderSlice'
import searchRdc from '../features/Search/searchResultsSlice'
import brandRdc from '../features/Brand/BrandSlice'

const RootReducer = combineReducers({
  userRdc,
  taxonRdc,
  filtersRdc,
  productsRdc,
  productBySlugRdc,
  productAssociationCtaRdc,
  cartOfferRdc,
  offerRequestRdc,
  cartRdc,
  orderRdc,
  searchRdc,
  brandRdc
});

export type RootState = ReturnType<typeof RootReducer>;
export default RootReducer;
